/* @jsx m */
import m from 'mithril';
import DeviceWrapper from '../components/DeviceWrapper.jsx';
import AppHeader from '../components/AppHeader.jsx';
import StatusBar from '../components/StatusBar.jsx';

export default function menuEtc() {
  return {
    view: () => {
      return (
        <DeviceWrapper>
        <StatusBar />
        <AppHeader />
        <div class="center-align" id="etc">
              <ul class="menu">
                <span class="notify"></span>
                <h2>Etc</h2>
                <li class="menu-item">
                  <button class="btn btn-link saveBtn">Clear Data</button>
                  <p class="bold">
                    This will permanently erase all save data!
                  </p>
                </li>
                <li class="menu-item">
                  <a class="btn btn-link backBtn" href="#/menu">
                    Back
                  </a>
                </li>
              </ul>
            </div>
      </DeviceWrapper>
      );
    }
  }
}